import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, reset, change } from 'redux-form';
import RaisedButton from 'material-ui/RaisedButton';
import moment from 'moment';

import { renderCheckBox, isValidNameWithSpace, renderDateField, renderAutoCompleteMultipleSelection, renderAutoCompleteSingleSelect, renderTextField, isInteger } from '../../../../../components/reduxFields';
import { getSkillAcquisitionGraphDCAction, getTargetsAndProgramsData, setGraphAnnotationAndBaselineBlank } from '../actions/index';
// import { base64Decode } from '../../../../../actions/utilAction';
import SkillAcuisitionGraphComponent from './SkillAcquisitionGraph';
import validate from './validate';

class SkillAcuisitionGraphContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
            ToDate: new Date(),
            patientId: props.patientId ? props.patientId : 0,
            masterPatientPrograms: '',
            masterPatientGoals: '',
            showGraph: '',
            xAxisName: null,
            yAxisName: null,
            yAxisMaxValue: null,
            disableYaxislabel: true,
            disableXaxislabel: true,
            disableLegend: true,
            hideGridlines: false,
            displayAverage: false,
            selectedProgram: '',
            graphTypeString: '',
            graphTitleString: '',
            graphType: [
                { id: 1, value: "% Correct Responding" },
                { id: 2, value: "Cumulative Mastery" },
                { id: 3, value: "PEAK Score" },
                // { id: 2, value: "Trials To Mastery" },
                // { id: 3, value: "Teaching Days To Mastery" }
            ],
            selectAllTargets: false,
            deSelectAllTargets: false,
            allTargets: [],
            programId: 0,
            displaySavedPhaseChangeLines: false,
            displayPhaseChangeLineForBaseline: false,
            displayphaseChangeLineWhenTheGoalWasMastered: false,      
            phaseChangeLineDataFlag : true,
            phaseChangeBaselineDataFlag : true,
            phaseChangeMasteredlineDataFlag : true,
            displayPhaseChangeLinesCheckbox: true,
            showTrendChart:false,
            isVisibleTrendCheckbox:false,
            selectedValues : [],
        }
        this.setPhaselineState = this.setPhaselineState.bind(this);
        this.setBaselineState = this.setBaselineState.bind(this);
        this.setMasteredlineState = this.setMasteredlineState.bind(this);
    }

    componentWillMount = () => {
        this.props.getTargetsAndProgramsData(this.state.patientId);
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            masterPatientPrograms: nextProps.masterPatientPrograms,
        });
    }

    onDateChange = (input, value) => {
        input.onChange(moment(value).format());
        this.setState({ [input.name]: value,
          displaySavedPhaseChangeLines: false,
          displayPhaseChangeLineForBaseline: false,
          displayphaseChangeLineWhenTheGoalWasMastered: false,    
          phaseChangeLineDataFlag : true,
          phaseChangeBaselineDataFlag : true,
          phaseChangeMasteredlineDataFlag : true
        }, () => { 
          this.props.dispatch(change('SkillAcuisitionGraphContainerForm', `displaySavedPhaseChangeLines`, false));
            this.props.dispatch(change('SkillAcuisitionGraphContainerForm', `displayPhaseChangeLineForBaseline`, false));
            this.props.dispatch(change('SkillAcuisitionGraphContainerForm', `displayphaseChangeLineWhenTheGoalWasMastered`, false));
         });
      }

    // onDateChange = (input, value) => {
    //     input.onChange(moment(value).format());
    //     this.setState({ [input.name]: value,
    //         displaySavedPhaseChangeLines: false,
    //         displayPhaseChangeLineForBaseline: false,
    //         displayphaseChangeLineWhenTheGoalWasMastered: false,    
    //         phaseChangeLineDataFlag : true,
    //         phaseChangeBaselineDataFlag : true,
    //         phaseChangeMasteredlineDataFlag : true
    //       }, () => { 
    //         this.props.dispatch(change('SkillAcuisitionGraphContainerForm', `displaySavedPhaseChangeLines`, false));
    //       this.props.dispatch(change('SkillAcuisitionGraphContainerForm', `displayPhaseChangeLineForBaseline`, false));
    //       this.props.dispatch(change('SkillAcuisitionGraphContainerForm', `displayphaseChangeLineWhenTheGoalWasMastered`, false));
    //         this.loadData();});
    // }

    setPhaselineState(phaseChangeLineDataFlag) {          
        this.setState({
          phaseChangeLineDataFlag : phaseChangeLineDataFlag,      
        });
      }
    
      setBaselineState(phaseChangeBaselineDataFlag) {          
        this.setState({      
          phaseChangeBaselineDataFlag : phaseChangeBaselineDataFlag,      
        });
      }
    
      setMasteredlineState(phaseChangeMasteredlineDataFlag) {          
        this.setState({
          phaseChangeMasteredlineDataFlag : phaseChangeMasteredlineDataFlag
        });
      }

    dataAnalyticsSubmit = (event) => {
        let patientId = this.state.patientId;
        let targetId = event.targetId;
        let graphTypeString = this.state.graphTypeString;
        let skillsAcquisitionProgramId = this.state.programId || 0;

        let showTrendGraph =  event.showTrendChart === undefined ? this.state.showTrendChart : event.showTrendChart
        if(!this.state.isVisibleTrendCheckbox){
            showTrendGraph = false;
        }

        if (patientId && targetId) {
            this.setState({
                showGraph: true,
                xAxisName: event.XAxisName,
                yAxisName: event.YAxisName,
                yAxisMaxValue: event.YAxisMaxValue,
                disableYaxislabel: event.disableYaxislabel === undefined ? this.state.disableYaxislabel : !event.disableYaxislabel,
                disableXaxislabel: event.disableXaxislabel === undefined ? this.state.disableXaxislabel : !event.disableXaxislabel,
                disableLegend: event.disableLegend === undefined ? this.state.disableLegend : !event.disableLegend,
                hideGridlines: event.hideGridlines === undefined ? this.state.hideGridlines : event.hideGridlines,
                displayAverage: event.displayAverage === undefined ? this.state.displayAverage : event.displayAverage,
                showTrendChart: showTrendGraph,
                graphTitleString: event.graphTitle,
                displaySavedPhaseChangeLines: event.displaySavedPhaseChangeLines === undefined ? this.state.displaySavedPhaseChangeLines : event.displaySavedPhaseChangeLines,
                displayPhaseChangeLineForBaseline: event.displayPhaseChangeLineForBaseline === undefined ? this.state.displayPhaseChangeLineForBaseline : event.displayPhaseChangeLineForBaseline,
                displayphaseChangeLineWhenTheGoalWasMastered: event.displayphaseChangeLineWhenTheGoalWasMastered === undefined ? this.state.displayphaseChangeLineWhenTheGoalWasMastered : event.displayphaseChangeLineWhenTheGoalWasMastered,
            });
        }
        let FromDate = event.FromDate ? moment(event.FromDate).format('YYYY-MM-DD') : moment(this.state.FromDate).format('YYYY-MM-DD');
        let ToDate = event.ToDate ? moment(event.ToDate).format('YYYY-MM-DD') : moment(this.state.ToDate).format('YYYY-MM-DD');
        // this.setState({
        //     FromDate: FromDate,
        //     ToDate: ToDate
        // })
        this.props.getSkillAcquisitionGraphDCAction(patientId, targetId, FromDate, ToDate, graphTypeString, skillsAcquisitionProgramId);
    }

    handleReset = () => {
        this.props.dispatch(reset('SkillAcuisitionGraphContainerForm'));
        this.setState({
            FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
            ToDate: new Date(),
            showGraph: ''
        })
    }

    programChangeHandler = (input, selected) => {
        input.onChange(selected.value)
        this.setState({ [input.name]: selected.value });
        let filteredMasterPatientGoals = [];
        filteredMasterPatientGoals = this.props.masterPatientGoals.filter(obj => {
            return obj.programId === selected.value
        });
        this.props.dispatch(change('SkillAcuisitionGraphContainerForm', 'targetId', null));
        this.setState({
            masterPatientGoals: filteredMasterPatientGoals,
            showGraph: '',
            selectedProgram: selected.label,
        },()=>this.props.setGraphAnnotationAndBaselineBlank());
    }

    handleNewRequestMultiSelect = (input, selectedValues) => {
        input.onChange(selectedValues);

        if(selectedValues.length === 1 ){
           this.setState({
            isVisibleTrendCheckbox: true
           }) 
        }else{
        this.setState({
            isVisibleTrendCheckbox: false
            }) 
        }
        this.setState({
            showGraph: '',
            selectedValues
        })

    }

    handleNewRequestGraphType = (input, selectedRecord) => {
        this.setState({
            showGraph: '',
        });
        input.onChange(selectedRecord.value);

        this.setState({ 
            displaySavedPhaseChangeLines: false,
            displayPhaseChangeLineForBaseline: false,
            displayphaseChangeLineWhenTheGoalWasMastered: false,    
            phaseChangeLineDataFlag : true,
            phaseChangeBaselineDataFlag : true,
            phaseChangeMasteredlineDataFlag : true
          }, () => { 
            this.props.dispatch(change('SkillAcuisitionGraphContainerForm', `displaySavedPhaseChangeLines`, false));
            this.props.dispatch(change('SkillAcuisitionGraphContainerForm', `displayPhaseChangeLineForBaseline`, false));
            this.props.dispatch(change('SkillAcuisitionGraphContainerForm', `displayphaseChangeLineWhenTheGoalWasMastered`, false));
          });

        if (selectedRecord.label.toUpperCase() === "% CORRECT RESPONDING") {
            this.setState({
                graphTypeString: 'PERCENTAGE CORRECT RESPONDING'
            }, () => this.props.dispatch(change('SkillAcuisitionGraphContainerForm', 'YAxisName', '% Correct Responding')));
        }
        else if (selectedRecord.label.toUpperCase() === 'CUMULATIVE MASTERY') {
            this.setState({
                graphTypeString: "CUMULATIVE MASTERY"
            }, () => this.props.dispatch(change('SkillAcuisitionGraphContainerForm', 'YAxisName', 'Cumulative Mastery Data')));
        }
        else if (selectedRecord.label.toUpperCase() === 'PEAK SCORE') {
            this.setState({
                graphTypeString: "PEAK SCORE"
            }, () => this.props.dispatch(change('SkillAcuisitionGraphContainerForm', 'YAxisName', 'PEAK SCORE')));
        }
        
        // else if (selectedRecord.label === 'Standard') {
        //     this.setState({
        //         graphTypeString: "STANDARD"
        //     }, () => this.props.dispatch(change('SkillAcuisitionGraphContainerForm', 'YAxisName', 'Standard Data')));
        // }        
        // else if (selectedRecord.label === 'Time of day') {
        //     this.setState({
        //         graphTypeString: "TIME OF DAY"
        //     }, () => this.props.dispatch(change('SkillAcuisitionGraphContainerForm', 'YAxisName', 'Time of Day (in 24 hour)')));
        // }
    }

    deselectAll = () => { //  Uncheck All Targets   
          let selectedTargets = [];
          this.props.dispatch(change('SkillAcuisitionGraphContainerForm', 'targetId', selectedTargets));         
          this.setState({ allTargets: [], selectedTarget: [] }, () => {
            this.setState({ allTargets: [{ deselectAll: true }, ...this.state.masterPatientGoals], deSelectAllTargets: true, selectAllTargets: false, selectedTarget: [] });
          });
      };
    
    selectAll = () => { //  Check All Targets 
          let selectedTargets = this.state.masterPatientGoals.map((obj) => obj.id);
          this.props.dispatch(change('SkillAcuisitionGraphContainerForm', 'targetId', selectedTargets));
          this.setState({ allTargets: [], selectedTarget: [] }, () => {
            this.setState({ allTargets: this.state.masterPatientGoals, selectAllTargets: true, deSelectAllTargets: false, selectedTarget: selectedTargets });
          });
      };

      checkDisable = (event, Id) => {   
        if(Id === 'displaySavedPhaseChangeLines')
        {
          this.setState({ displaySavedPhaseChangeLines: event.target.checked ? true : false,
            phaseChangeLineDataFlag : true,        
          });      
        }
        else if(Id === 'displayPhaseChangeLineForBaseline')
        {
          this.setState({ displayPhaseChangeLineForBaseline: event.target.checked ? true : false,
            phaseChangeBaselineDataFlag : true,        
          });      
        }
        else if(Id === 'displayphaseChangeLineWhenTheGoalWasMastered')
        {
          this.setState({ displayphaseChangeLineWhenTheGoalWasMastered: event.target.checked ? true : false,
            phaseChangeMasteredlineDataFlag : true,
          });      
        } 
      }

    render() {
        const { handleSubmit } = this.props;
        return (
            <div>
                <div className="clearfix"></div>
                <div className="readmin-panel">
                    <div className="panel-body">
                        <form className="readmin-form custom_form" onSubmit={handleSubmit(this.dataAnalyticsSubmit)}>
                            <div className='row'>
                                <div className="col-sm-6 mt-20 require">
                                    <Field
                                        name='programId'
                                        label="Program Name"
                                        options={this.state.masterPatientPrograms}
                                        handleNewRequest={(input, selected) => this.programChangeHandler(input, selected)}
                                        component={renderAutoCompleteSingleSelect}
                                    />
                                </div>
                                <div className="col-sm-6 mt-10">
                                    <div className="row">
                                        <div className="col-sm-12">                                           
                                            <div className="sech_item_team">                     
                                                <span className={this.state.selectAllTargets ? 'active' : ''} onClick={this.selectAll.bind(this)}>( Select All Targets </span>
                                                <span className={this.state.deSelectAllTargets ? 'active' : ''} onClick={this.deselectAll.bind(this)}>Deselect All Targets ) </span>
                                            </div>                                           
                                        </div>
                                        <div className="col-sm-12 require">
                                            <Field
                                                name='targetId'
                                                // hintText="Target Name"
                                                options={this.state.masterPatientGoals}
                                                handleNewRequest={this.handleNewRequestMultiSelect}
                                                component={renderAutoCompleteMultipleSelection}
                                            />
                                        </div>
                                    </div>   
                                    
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-sm-6 mt-10">
                                    <Field
                                        name="FromDate"
                                        placeholder="From Date"
                                        locale="en-US"
                                        selected={this.state.FromDate}
                                        onDateChange={this.onDateChange}
                                        openToYearSelection={true}
                                        component={renderDateField} />
                                </div>
                                <div className="col-sm-6 mt-10">
                                    <Field
                                        name="ToDate"
                                        placeholder="To Date"
                                        locale="en-US"
                                        minDate={this.state.FromDate}
                                        selected={this.state.ToDate}
                                        openToYearSelection={true}
                                        onDateChange={this.onDateChange}
                                        component={renderDateField} />
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-sm-6 mt-40 require">
                                    <Field
                                        name='graphTypeId'
                                        label="Graph Type"
                                        options={this.state.graphType}
                                        handleNewRequest={this.handleNewRequestGraphType}
                                        component={renderAutoCompleteSingleSelect}
                                    />
                                </div>
                                <div className="col-sm-6 mt-10">
                                    <Field
                                        name="graphTitle"
                                        type="text"
                                        maxLength="100"
                                        label="Graph Title"
                                        normalize={isValidNameWithSpace}
                                        component={renderTextField}
                                    />
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-sm-6 mt-10">
                                    <Field
                                        name="XAxisName"
                                        type="text"
                                        maxLength="250"
                                        label="X-Axis Name"
                                        normalize={isValidNameWithSpace}
                                        component={renderTextField}
                                    />
                                </div>
                                <div className="col-sm-6 mt-10">
                                    <Field
                                        name="YAxisName"
                                        type="text"
                                        maxLength="250"
                                        label="Y-Axis Name"
                                        normalize={isValidNameWithSpace}
                                        component={renderTextField}
                                    />
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-sm-3 mt-10">
                                    <Field
                                        name="YAxisMaxValue"
                                        type="text"
                                        maxLength="4"
                                        label="Y-Axis Max Value"
                                        normalize={isInteger}
                                        component={renderTextField}
                                    />
                                </div>
                                <div className="col-sm-3 mt-10">
                                    <Field
                                        className="mt20 mb0"
                                        name="disableLegend"
                                        label="Disable Legends"
                                        component={renderCheckBox} />
                                </div>
                                <div className="col-sm-3 mt-10">
                                    <Field
                                        className="mt20 mb0"
                                        name="hideGridlines"
                                        label="Hide Gridlines"
                                        component={renderCheckBox} />
                                </div>
                                <div className="col-sm-3 mt-10">
                                    <Field 
                                        className="mt20 mb0" 
                                        name="displayAverage" 
                                        label="Display Average"                                       
                                        component={renderCheckBox} />
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-sm-3 mt-10">
                                    <Field
                                        className="mt20 mb0"
                                        name="disableXaxislabel"
                                        label="Disable X Axis Label"
                                        component={renderCheckBox} />
                                </div>
                                <div className="col-sm-3 mt-10">
                                    <Field
                                        className="mt20 mb0"
                                        name="disableYaxislabel"
                                        label="Disable Y Axis Label"
                                        component={renderCheckBox} />
                                </div>
                                {this.state.displayPhaseChangeLinesCheckbox &&
                                <div className="col-sm-3 mt-10">
                                    <Field 
                                        className="mt20 mb0" 
                                        name="displaySavedPhaseChangeLines" 
                                        label="Display saved phase change lines"
                                        onChange={(e) => this.checkDisable(e, 'displaySavedPhaseChangeLines')}
                                        component={renderCheckBox} />
                                </div>}
                                {this.state.displayPhaseChangeLinesCheckbox &&
                                <div className="col-sm-3 mt-10">
                                    <Field 
                                        className="mt20 mb0" 
                                        name="displayPhaseChangeLineForBaseline" 
                                        label="Display baseline phase change line"
                                        onChange={(e) => this.checkDisable(e, 'displayPhaseChangeLineForBaseline')}
                                        component={renderCheckBox} />
                                </div>}
                            </div>
                            <div className='row'>
                                {this.state.displayPhaseChangeLinesCheckbox &&
                                <div className="col-sm-3 mt-10">
                                    <Field 
                                        className="mt20 mb0" 
                                        name="displayphaseChangeLineWhenTheGoalWasMastered" 
                                        label="Display mastered phase change line"
                                        onChange={(e) => this.checkDisable(e, 'displayphaseChangeLineWhenTheGoalWasMastered')}
                                        component={renderCheckBox} />
                                </div>}
                                { this.state.isVisibleTrendCheckbox &&<div className="col-sm-3 mt-10">
                                    <Field
                                    className="mt20 mb0" 
                                    name="showTrendChart"
                                    label="Display Trendlines"
                                    component={renderCheckBox}
                                    // onChange={(e) => console.log("e",e)}
                                    />
                                </div>}
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 btn_rt reset-btn claims_filter mt-20">
                                <RaisedButton className="grey_btn" type="Submit" primary={true}>Generate Graph</RaisedButton>
                                <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                            </div>
                        </form>
                    </div>
                    {this.state.showGraph !== '' && <div>
                        {
                            this.props.dcSkillAcquisitionGraph.loading === true
                                ?
                                <div className='row'>
                                    <div className="col-sm-12 text-center no-record" >Loading...</div>
                                </div>
                                :
                                <SkillAcuisitionGraphComponent
                                    FromDate={this.state.FromDate}
                                    ToDate={this.state.ToDate}
                                    xAxisName={this.state.yAxisName}
                                    yAxisName={this.state.xAxisName}
                                    yAxisMaxValue={this.state.yAxisMaxValue}
                                    disableYaxislabel={this.state.disableYaxislabel}
                                    disableLegend={this.state.disableLegend}
                                    hideGridlines={this.state.hideGridlines}
                                    displayAverage={this.state.displayAverage}
                                    showTrendChart = {this.state.showTrendChart}
                                    disableXaxislabel={this.state.disableXaxislabel}
                                    selectedProgram={this.state.selectedProgram}
                                    graphTitle={this.state.graphTitleString || this.state.selectedProgram}
                                    displaySavedPhaseChangeLines = {this.state.displaySavedPhaseChangeLines}  displayPhaseChangeLineForBaseline = {this.state.displayPhaseChangeLineForBaseline}  displayphaseChangeLineWhenTheGoalWasMastered = {this.state.displayphaseChangeLineWhenTheGoalWasMastered} 
                                    phaseChangeLineDataFlag = {this.state.phaseChangeLineDataFlag}  phaseChangeBaselineDataFlag = {this.state.phaseChangeBaselineDataFlag}  phaseChangeMasteredlineDataFlag = {this.state.phaseChangeMasteredlineDataFlag}  
                                    setPhaselineState={this.setPhaselineState} setBaselineState={this.setBaselineState} setMasteredlineState={this.setMasteredlineState}
                                />
                        }
                    </div>}
                </div>
            </div>
        )
    }
}

SkillAcuisitionGraphContainer = reduxForm({
    form: 'SkillAcuisitionGraphContainerForm',
    validate,
    enableReinitialize: true,
})(SkillAcuisitionGraphContainer);

function mapStateToProps(state) {
    let masterPatientGoals = [];
    let masterPatientPrograms = [];

    if (state.dcSkillAcquisitionGraph.targetsAndProgramsData) {
        masterPatientGoals = state.dcSkillAcquisitionGraph.targetsAndProgramsData.data.Targets || [];
        masterPatientPrograms = state.dcSkillAcquisitionGraph.targetsAndProgramsData.data.Programs || [];
    }
    return {
        loading: state.patient.loading || state.patient.loadingMasterData,
        masterPatientGoals: masterPatientGoals,
        masterPatientPrograms: masterPatientPrograms,
        dcSkillAcquisitionGraph: state.dcSkillAcquisitionGraph,
    };
}

export default connect(mapStateToProps, { getTargetsAndProgramsData, getSkillAcquisitionGraphDCAction, setGraphAnnotationAndBaselineBlank })(SkillAcuisitionGraphContainer);



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollectionGraph/SkillAcuisitionGraph/index.js